import { path } from "../../config";
import fetchServer from "../fetchServer";
import { store } from "../../redux/store";

export async function resetStaffPasswordReq(data) {
  let result = {return: 0,msg: "Something went wrong creating Staff."}

  let token = store.getState().user.userData.accessToken;

  console.log('req Got: ',data)

  await fetchServer({method: 'POST',url: path.api+"/partners/corporate/reset-staff-password",data,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((res) => {
    console.log('serv => ',res);
    if(res.data && !res?.error)
      result = {return: 1,msg: "Successfull",data: res.data}
    else if(res.error) result['msg'] = res.error.message;
  })
  .catch((e) => {
    console.log("Network Error: ",e)
  })

  return result;

}